var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{key:_vm.registred},[(!_vm.registred)?_c('registrationForm',{attrs:{"callback":function(ret){ _vm.registred = true; }}}):_c('registrationSuccess')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }